// 越南時區工具 — 專案資料庫所有日期欄位皆視為「越南當地牆鐘時間 (Asia/Ho_Chi_Minh, UTC+7)」
// 不論瀏覽器位於何處，都應該以相同的牆鐘時間顯示。

export const VN_TZ = 'Asia/Ho_Chi_Minh';
const VN_OFFSET = '+07:00';

const isTimezoned = (s) => /[Zz]|[+-]\d{2}:?\d{2}$/.test(s);

// 把 DB 儲存的裸字串（例如 "2026-06-05 10:00:00" 或 "2026-06-05"）轉成 Date 物件，
// 並明確視為越南當地時間，避免被瀏覽器本地時區誤解。
export const parseVN = (input) => {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input;
  let s = String(input).trim();
  if (!s) return null;
  if (s.includes(' ') && !s.includes('T')) s = s.replace(' ', 'T');
  if (s.length === 10) s += 'T00:00:00';
  if (!isTimezoned(s)) s += VN_OFFSET;
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
};

// 將任何時間（包含 Date 物件 / 裸字串）格式化成越南牆鐘時間字串
export const formatVN = (input, opts = {}) => {
  const d = input instanceof Date ? input : parseVN(input);
  if (!d) return '';
  return d.toLocaleString('sv-SE', {
    timeZone: VN_TZ,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    ...opts,
  }).replace('T', ' ');
};

// 取得目前越南時間，輸出 "YYYY-MM-DD HH:mm:ss"
export const nowVN = () => new Date().toLocaleString('sv-SE', { timeZone: VN_TZ }).replace('T', ' ');

// 把「目前越南時間」轉成 Date 物件，表示與 DB 裸字串同一參考座標（越南牆鐘）
// 用於和 new Date(activity.a_Sdate) 之類做比較
export const nowVNDate = () => new Date(nowVN());
